import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LinkPdf, Payment } from '../interfaces/store';


const initialState: Payment = {
    succeed: false
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setValue(state, action: PayloadAction<Boolean>) {
        state.succeed = action.payload
    },
  },
});

export const { setValue } = paymentSlice.actions;
export default paymentSlice.reducer;